import * as types from '../types'

const state = {
  loading: false,
  casePickInfo: null
}

const actions = {
  setLoading ({ commit }, value) {
    commit(types.LOADING, value)
  },
  setCasePicker({ state }, val = null) {
    state.casePickInfo = val;
    if (val) {
      sessionStorage.setItem('casePicker', JSON.stringify(val));
    } else if (sessionStorage.getItem('casePicker')) {
      sessionStorage.removeItem('casePicker');
    }
  },
  addCasePicks({ state }, id) {
    if (!state.casePickInfo) {
      return;
    }
    state.casePickInfo = {
      ...state.casePickInfo,
      picks: [...new Set([...state.casePickInfo.picks, id])]
    }
    sessionStorage.setItem('casePicker', JSON.stringify(state.casePickInfo));
    localStorage.setItem('casePickerSync', JSON.stringify(state.casePickInfo));
    setTimeout(() => localStorage.removeItem('casePickerSync'), 0);
    window.open(`${state.casePickInfo.originUrl}#/page-jumper?s_key=${state.casePickInfo.sKey}&s_data=${id}`, '_blank');
  }
}

const getters = {
  loading: state => state.loading,
  casePickInfo: state => state.casePickInfo,
  curCasePicks: state => state.casePickInfo ? state.casePickInfo.picks : []
}

const mutations = {
  [types.LOADING] (state, res) {
    state.loading = res
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js